var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMedium = function SvgMedium(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.47768 2 2 6.47768 2 12C2 17.5223 6.47768 22 12 22C17.5223 22 22 17.5223 22 12C22 6.47768 17.5223 2 12 2ZM17.7143 7.66295L16.8036 8.53571C16.7232 8.59598 16.6853 8.6942 16.7009 8.79018V15.2121C16.6853 15.3103 16.7232 15.4085 16.8036 15.4665L17.6964 16.3393V16.5335H13.2143V16.3482L14.1362 15.4531C14.2277 15.3616 14.2277 15.3348 14.2277 15.1987V10.0022L11.6607 16.5112H11.3147L8.32812 10.0022V14.3661C8.30134 14.5491 8.36607 14.7344 8.49554 14.8661L9.69643 16.3192V16.5134H6.28571V16.3192L7.48661 14.8661C7.54988 14.8007 7.59697 14.7214 7.6241 14.6346C7.65123 14.5478 7.65766 14.4558 7.64286 14.3661V9.32143C7.65848 9.1808 7.60491 9.04464 7.49777 8.94866L6.4308 7.66295V7.46875H9.74554L12.3036 13.0826L14.5558 7.47321H17.7143V7.66295Z",
    fill: "#A8A9AC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedium, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medium.04602f19.svg";
export { ForwardRef as ReactComponent };